import { render } from "./GoBackButton.vue?vue&type=template&id=498b06a0&ts=true"
import script from "./GoBackButton.vue?vue&type=script&lang=ts"
export * from "./GoBackButton.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/shared/utils/GoBackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "498b06a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('498b06a0', __exports__)) {
    api.reload('498b06a0', __exports__)
  }
  
  module.hot.accept("./GoBackButton.vue?vue&type=template&id=498b06a0&ts=true", () => {
    api.rerender('498b06a0', render)
  })

}


export default __exports__